import { Datagrid, DateField, FunctionField, ReferenceField, TextField } from "react-admin";
import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import { getTheme } from "customStyles/utils";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import GradeHistoryModal from "components/Users/Students/Modals/GradeHistoryModal";
import ChangeGradeModal from "components/Users/Students/Modals/ChangeGrade";

// Shared column set for all three grade tables. Rows come from the surrounding ListContext.
// showTypeColumn is off for the flat tables, whose heading already states the type.
const GradesDatagrid = ({ educationId, onGradeChanged, showTypeColumn = true }) => {
  const theme = getTheme(settings.tenant);

  return (
    <Datagrid
      rowClick={false}
      bulkActionButtons={false}
      sx={settings.style.secondaryDatagrid}
    >
      <ReferenceField
        label="Дисциплина"
        source="disciplineId"
        reference={administrationRequests.getDisciplinesSelect()}
        sortable={false}
      >
        <TextField
          source="name"
          label="Дисциплина"
        />
      </ReferenceField>

      {showTypeColumn && (
        <TextField
          source="disciplineTypeLabel"
          label=""
        />
      )}

      <FunctionField
        label="Оценка"
        render={rec => (
          <TextField
            color={+rec.grade === 2 ? theme.palette.error.primary : null}
            source="grade"
            emptyText="-"
          />
        )}
      />
      <DateField
        source="gradedOn"
        label="Дата на оценка"
        locales="bg-BG"
      />
      <FunctionField
        label="История на оценки"
        render={rec => (
          <GradeHistoryModal
            id={educationId}
            record={rec}
          />
        )}
      />
      <SecuredComponent
        permission={permissions.canManageStudentsAllDisciplinesGrades}
        label="Редакция на оценка"
      >
        <FunctionField
          render={rec => (
            <ChangeGradeModal
              record={rec}
              educationId={educationId}
              fetchGrades={onGradeChanged}
            />
          )}
        />
      </SecuredComponent>
      <TextField
        source="note"
        label="Коментар"
      />
    </Datagrid>
  );
};

export default GradesDatagrid;
